// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
};

const actions = {
  NewDocument_Pending({ commit }, UserAndPage) {
    const UserInfo = {
      name: UserAndPage.User.name,
      role: UserAndPage.User.role,
      subroles: UserAndPage.User.subroles,
      page: UserAndPage.page,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/archivedrequests',
        method: 'POST',
        data: UserInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          // commit('SET_NEW_DOCUMENT', resp.data)
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  IsOpened_Pending({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/requestopened',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  NewDocumentEditing_Pending({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/updaterequestdetails',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
